import { Modal } from 'antd';
import styled from 'styled-components';

export const ScreenRecordingPolicyModalStyled = styled(Modal)`
    .ant-modal-content {
        padding: 2rem;
    }
    .ant-modal-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        padding: 0;
    }

    h1 {
        font-size: 1.25rem;
        font-weight: 500;
        margin: 0;
        color: var(--secondary) !important;
        margin-top: 1rem;
        margin-bottom: 0.25rem;
    }

    p {
        color: var(--grey2) !important;
    }

    svg {
        width: 100%;
        height: auto;
        max-width: 250px;
    }

    b {
        font-weight: 600;
    }

    button {
        margin-top: 2rem;
        background-color: #1798e8;
        color: #fff;
        width: 100%;
        max-width: 150px;
    }
`;
